export enum AvailableLocale
{
    ITALIAN         = "it",
    ENGLISH         = "it",
    DEFAULT         = "it"
}